import React, { useState, useEffect,useRef  } from "react";
import { useLanguage } from '../contexts/LanguageContext';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './SuiteType.css';
import { Link } from 'react-router-dom';
import { optimizedSrc, optimizedSrcSet } from '../config/optimizedImages';


const RoomCard = ({ setBgColor }) => {
  const { t } = useLanguage();
  
  const roomData = t('suiteCards.rooms');
  
  const roomTypes = [
    {
      id: 1,
      imageBase: '711A8132',
      name: roomData[0].name,
      description: roomData[0].description,
      urlis:'/LuxurySuites',
    },
    {
      id: 2,
      imageBase: '711A8524',
      name: roomData[1].name,
      description: roomData[1].description,
      urlis:'/LuxuryVips',
    },
    {
      id: 3,
      imageBase: '711A8063',
      name: roomData[2].name,
      description: roomData[2].description,
      urlis:'/LuxuryDomi',
    },
    {
      id: 4,
      imageBase: '711A8580',
      name: roomData[3].name,
      description: roomData[3].description,
      urlis:'/LuxuryVilla',
    },
  ];
  const [activeIndex, setActiveIndex] = useState(0);
  const roomCardRef = useRef(null);
  const sliderRef = useRef(null);
  const [prevIndex, setPrevIndex] = useState(0);

  const settings = {
    dots: true,
    infinite: true,
    centerMode: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerPadding: getCenterPadding(),
    speed: 600,
    className: "slider",
    beforeChange: (current, next) => setActiveIndex(next),
  };

  function getCenterPadding() {
    const screenWidth = window.innerWidth;
    if (screenWidth >= 1400) {
      return "550px"; // Adjust this value for desktop
    } else if (screenWidth >= 1200) {
      return "450px"; // Adjust this value for tablets
    }else if (screenWidth >= 1000) {
      return "350px"; // Adjust this value for tablets
    }else if (screenWidth >= 768) {
      return "250px"; // Adjust this value for tablets
    } else if (screenWidth >= 600) {
      return "130px"; // Adjust this value for tablets
    } else if (screenWidth >= 500) {
      return "50px"; // Adjust this value for tablets
    } else {
      return "0px"; // No padding for mobile
    }
  }
  
  
  // function getSlidesToShow() {
  //   const screenWidth = window.innerWidth;
  //   if (screenWidth >= 1200) {
  //     return 1; // Adjust this value for desktop
  //   } else if (screenWidth >= 768) {
  //     return 1; // Adjust this value for tablets
  //   } else {
  //     return 1; // Display only one slide for mobile
  //   }
  // }
  useEffect(() => {
    const slideBackground = document.querySelector('.slider-background');
    if (slideBackground) {
      slideBackground.style.backgroundImage = `url('${optimizedSrc(roomTypes[activeIndex].imageBase, 1920)}')`;
    }
  }, [activeIndex, roomTypes]);

  useEffect(() => {
    const checkScrollPosition = () => {
      if (!roomCardRef.current) return;
      const roomCardPosition = roomCardRef.current.getBoundingClientRect().top;
      if (roomCardPosition <= 70) {
        setBgColor('#2d2d2d');
      } else {
        setBgColor('white');
      }
    };

    window.addEventListener('scroll', checkScrollPosition);
    return () => window.removeEventListener('scroll', checkScrollPosition);
  }, []);
  const handleClick = (id) => {
    if ((activeIndex < id || (id==1 && activeIndex==3)) && (!(id==4 && activeIndex==0)) ) {
        sliderRef.current.slickNext();
    } else {
      sliderRef.current.slickPrev();
    }
    //console.log(id, 'is id');
    //console.log(activeIndex, 'is  active id');
  };
  return (
    <div className="room-card-container" id="room-type" ref={roomCardRef}>
      <div className="slider-background"></div>
      <p className="all-suites-note">{t('suiteCards.allSuitesNote')}</p>
      <Slider ref={sliderRef} {...settings}>
        {roomTypes.map((room) => (
          <div className="room-card" key={room.id} onClick={() => handleClick(room.id)}>
            <div className="room-details">
              <h2 className="room-name">{room.name}</h2>
              {roomData[room.id - 1].facts && (
                <p className="room-facts">{roomData[room.id - 1].facts}</p>
              )}
            </div>
            <div className="img-container">
              <img
                src={optimizedSrc(room.imageBase)}
                srcSet={optimizedSrcSet(room.imageBase)}
                sizes="(max-width: 768px) 100vw, 60vw"
                loading="lazy"
                decoding="async"
                alt={room.name}
                className="room-image"
              />
            </div>
            <div className="room-details">
              <p className="room-description">{room.description}</p>
              <div className="more-details">
                <button className="more-details-button"><Link to={room.urlis}   
                onClick={() => {
                  window.scroll(0, 0);
                }}>{t('suiteCards.moreDetails')}</Link></button>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default RoomCard;